// extracted by mini-css-extract-plugin
export var bounce = "_pe-1";
export var generatingText = "_pe-6";
export var lightning = "_pe-4";
export var popup = "_pe-5";
export var progressBar = "_pe-7";
export var progressFill = "_pe-8";
export var progressShimmer = "_pe-9";
export var progressText = "_pe-a";
export var shimmer = "_pe-3";
export var uploadIcon = "_pe-0";
export var uploadingText = "_pe-2";